/**
 * Tiny client-side CSV download helper. Used by the clinical-ops detail
 * screens where the filter set is rich enough that round-tripping every
 * permutation through a backend export endpoint isn't worth it — the data
 * is already on the page.
 *
 * Quoting rules follow RFC 4180: any field containing a comma, quote, or
 * newline gets wrapped in double-quotes, with internal quotes doubled.
 */
export function downloadCsv<T>(
  filename: string,
  columns: { key: keyof T & string; label: string }[],
  rows: T[]
): void {
  const header = columns.map((c) => csvField(c.label)).join(',');
  const body = rows
    .map((r) =>
      columns
        .map((c) => {
          const v = (r as Record<string, unknown>)[c.key];
          return csvField(v == null ? '' : String(v));
        })
        .join(',')
    )
    .join('\n');
  const blob = new Blob([`${header}\n${body}\n`], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function csvField(value: string): string {
  if (value === '') return '';
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}
